<template>
  <div class="bootscreen-div">
    <!-- <div class="signbuttoncontent">
      <van-field v-model="cardNumber" placeholder="请输入卡号" />
      <van-button type="primary" @click="clickScanCard">签到</van-button>
    </div> -->
    <div class="bootscreen-top">
      <img class="bootscreen-top-logo" v-if="headerLogo && headerLogo.length > 0" :src="headerLogo | imgFormat" alt="" />
      <div class="bootscreen-top-logo" v-else></div>
      <div class="bootscreen-top-timediv">
        <div class="timediv-clock">{{timeString}}</div>
        <div class="timediv-date">{{dateString}}</div>
      </div>
    </div>
    <div class="bootscreen-middle">
      <img class="bootscreen-middle-logo" v-if="hasLogo" src="../../../public/img/product/bootScreen/img-left.png" alt="">
      <div class="bootscreen-middle-content">
        <div class="content-header"></div>
        <div class="content-main">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <div v-if="hiddenTab" class="bootscreen-hotline" @click="$router.back()">
      <div class="iconfont icon-icon-back"></div>
      <div class="bootscreen-hotline-text">返回</div>
    </div>
    <div v-else class="bootscreen-bottom">
      <div v-for="(item,index) in bottomButtonArr" :key="'bootscreen-bottom-item' + index" class="bootscreen-bottom-item" :class="index == selectIndex ? 'bootscreen-bottom-item-selected' : ''">
        <div class="button-content" @click="selectTabButton(index)">
          <img class="button-logo" :src="bottomImageIcon[index]" alt="">
          <div class="button-text">{{item}}</div>
        </div>
        <img class="button-shadow" src="../../../public/img/product/bootScreen/btn-shadow.png" alt="">
      </div>
    </div>
    <van-dialog
      class="bootscreensignin-dialog"
      v-model="showMistakeAddressDialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
      :close-on-click-overlay="true"
      get-container="#app"
    >
      <div class="dialog-maindiv">
        <div class="dialog-closebuttondiv">
          <div class="dialog-closenotice">点击任意阴影处关闭</div>
          <div
            class="dialog-closebutton"
            @click="showMistakeAddressDialog = false"
          >
            <span class="iconfont icon-icon_wrong"></span>
          </div>
        </div>
        <div class="dialog-maininfo">
          <mistake-sign-in-address :attendInfo="attendInfo" :addressInfo="addressInfo" :currentPlace="currentAddress"></mistake-sign-in-address>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import mistakeSignInAddress from "./bootScreenSignIn/mistakeSignInAddress.vue";
export default {
  data(){
    return{
      headerLogo: dsf.config.setting_screen_horizontal_top_picture,
      weekArr: ["星期天","星期一","星期二","星期三","星期四","星期五","星期六"],
      timeString: "",
      dateString: "",
      bottomImageIcon:[],
      timer: null,
      errorAddressTimer: null,
      bottomButtonArr: [],
      bottomButtonPath: [],
      selectIndex: 0,
      hasLogo: true,
      hiddenTab: false,
      showMistakeAddressDialog: false,
      addressInfo: {},
      currentAddress: "",
      attendInfo: {},
      cardNumber:"",
    }
  },
  components: {
    mistakeSignInAddress,
  },
  mounted(){
    this.settingPageFunction();
    window.swipingCardFunction = this.swipingCardFunction;
    this.checkPageStatus();
    this.timer = setInterval(()=>{
      this.updateTime();
      this.autoOpenSignInPage();
    },1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.errorAddressTimer) {
      clearTimeout(this.errorAddressTimer);
    }
  },
  beforeRouteUpdate(to, from, next) {
    if(to.path.indexOf('bootScreenSignIn') == -1){
      window.swipingCardFunction = this.swipingCardFunction;
    }
    next();
  },
  watch:{
    '$route.path': function(newVal , oldVal){
      this.checkPageStatus();
    }
  },
  methods:{
    settingPageFunction() {
      let tempString = sessionStorage.getItem("deviceInfo");
      if (tempString && tempString.length > 0) {
        let tempDeviceData = JSON.parse(tempString);
        let tempArray = tempDeviceData.verticalReleaseTypeList || [];
        let tempBottomButtonArr = [];
        let tempBottomButtonPath = [];
        let tempBottomButtonIcon = [];
        tempArray.forEach((item) => {
          tempBottomButtonArr.push(item.moduleName);
          switch (parseInt(item.moduleId)) {
            case 1: {
              tempBottomButtonPath.push("schoolIntroduction");
              tempBottomButtonIcon.push(require("../../../public/img/product/bootScreen/bootscreen-xyjj.png"));
              break;
            }
            case 2: {
              tempBottomButtonPath.push("campusDynamic");
              tempBottomButtonIcon.push(require("../../../public/img/product/bootScreen/bootscreen-xydt.png"));
              break;
            }
            case 3: {
              tempBottomButtonPath.push("announcements");
              tempBottomButtonIcon.push(require("../../../public/img/product/bootScreen/bootscreen-tzgg.png"));
              break;
            }
            case 4: {
              tempBottomButtonPath.push("curriculum");
              tempBottomButtonIcon.push(require("../../../public/img/product/bootScreen/bootscreen-bjkc.png"));
              break;
            }
            case 5: {
              tempBottomButtonPath.push("classroomArrangement");
              tempBottomButtonIcon.push(require("../../../public/img/product/bootScreen/bootscreen-jsap.png"));
              break;
            }
            default:
              break;
          }
        });
        this.bottomButtonArr = tempBottomButtonArr;
        this.bottomButtonPath = tempBottomButtonPath;
        this.bottomImageIcon = tempBottomButtonIcon;
        this.currentAddress = tempDeviceData.classroomText || "";
      }
    },
    formatTime(num , digit){
      let zero = "";
      for(let i = 0; i < digit; i ++){
        zero +="0";
      }
      return (zero + num).slice(-digit);
    },
    updateTime(){
      let nowDate = new Date();
      this.timeString = this.formatTime(nowDate.getHours() , 2) + ":" + this.formatTime(nowDate.getMinutes() , 2) + ":" + this.formatTime(nowDate.getSeconds() , 2);
      this.dateString = nowDate.getFullYear() + "年" + (nowDate.getMonth() + 1) + "月" + nowDate.getDate() + "日" + " " + this.weekArr[nowDate.getDay()];
    },
    selectTabButton(index){
      this.selectIndex = index;
      this.$router.push({
        path: "/mobile/bootScreen/transverse/" + this.bottomButtonPath[index],
      });
    },
    checkPageStatus(){
      if(this.$route.meta){
        if(this.$route.meta.hiddenLogo){
          this.hasLogo = (this.$route.meta.hiddenLogo == 1 ? false : true);
        }else{
          this.hasLogo = true;
        }
        if(this.$route.meta.hiddenTab){
          this.hiddenTab = (this.$route.meta.hiddenTab == 1 ? true : false);
        }else{
          this.hiddenTab = false;
        }
      }else{
        this.hasLogo = true;
        this.hiddenTab = false;
      }
      let path = this.$route.path || "";
      this.bottomButtonPath.forEach((item,index)=>{
        if(path.indexOf(item) > -1){
          this.selectIndex = index;
          return;
        }
      });
    },
    autoOpenSignInPage() {
      if(this.$route.path.indexOf('bootScreenSignIn') > -1){
        return;
      }
      let tempSecond = new Date().getSeconds();
      if (tempSecond == 3) {
        let _this = this;
        this.$http
          .get(
            "/teas/screen/pollingCurrentClassroomArrangement",
            {
              equipmentId: sessionStorage.getItem("equipmentId") || "",
            },
            {},
            $$webRoot.default
          )
          .done(({ success, data, message }) => {
            if (success) {
              let tempData = data || {};
              if (!dsf.isEmptyObject(tempData)) {
                let tempArrayString =
                  sessionStorage.getItem("autoJumpList") || "";
                if (tempArrayString.length > 0) {
                  let tempArray = JSON.parse(tempArrayString);
                  if (
                    tempData.id &&
                    tempData.id.length > 0 &&
                    tempArray.indexOf(tempData.id) == -1
                  ) {
                    tempArray.push(tempData.id);
                    sessionStorage.setItem(
                      "autoJumpList",
                      JSON.stringify(tempArray)
                    );
                    var url =
                      "/mobile/bootScreen/transverse/bootScreenSignIn?id=" +
                      tempData["id"] +
                      "&relId=" +
                      tempData["relId"] +
                      "&courseNoonId=" +
                      tempData["courseNoonId"] +
                      "&type=" +
                      tempData["typeValue"] +
                      "&attendMode=" +
                      tempData["courseAttendMode"];
                    _this.$router.push({
                      path: url,
                    });
                  }
                } else {
                  let tempArray = [];
                  tempArray.push(tempData.id);
                  sessionStorage.setItem(
                    "autoJumpList",
                    JSON.stringify(tempArray)
                  );
                  var url =
                    "/mobile/bootScreen/transverse/bootScreenSignIn?id=" +
                    tempData["id"] +
                    "&relId=" +
                    tempData["relId"] +
                    "&courseNoonId=" +
                    tempData["courseNoonId"] +
                    "&type=" +
                    tempData["typeValue"] +
                    "&attendMode=" +
                    tempData["courseAttendMode"];
                  _this.$router.push({
                    path: url,
                  });
                }
              }
            } else {
              // dsf.layer.message(message, false);
            }
          })
          .error((err) => {
            // dsf.layer.message(err.message || "请求异常", false);
          });
      }
    },
    //刷卡调用方法
    swipingCardFunction(cardId, faceInfo) {
      let _this = this;
      this.$http
        .post(
          "/teas/screen/payByCard",
          {
            cardId: cardId || "",
            faceInfo: faceInfo || "",
            equipmentId: sessionStorage.getItem("equipmentId") || "",
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            if (_this.showMistakeAddressDialog) {
              _this.showMistakeAddressDialog = false;
            }
            if (_this.errorAddressTimer) {
              clearTimeout(_this.errorAddressTimer);
            }
            let code =
              data.signMessage && data.signMessage.errorCode
                ? data.signMessage.errorCode
                : 0;
            switch (code) {
              case 30004: {
                _this.addressInfo = data.jumpArrange || {};
                _this.attendInfo = data.signMessage || {};
                _this.showMistakeAddressDialog = true;
                let tempThis = _this;
                _this.errorAddressTimer = setTimeout(() => {
                  tempThis.showMistakeAddressDialog = false;
                }, 10000);
                break;
              }
              case 30005: {
                dsf.layer.message(data.signMessage.errorText || "", false);
                break;
              }
              case 30007: {
                //跳转课程
                let tempObject = data.currentArrange || {};
                _this.jumpNextPage(tempObject, cardId, faceInfo);
                break;
              }
              default:
                break;
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    jumpNextPage(dataObject, cardId, faceInfo) {
      var url =
        "/mobile/bootScreen/transverse/bootScreenSignIn?id=" +
        dataObject["id"] +
        "&relId=" +
        dataObject["relId"] +
        "&courseNoonId=" +
        dataObject["courseNoonId"] +
        "&type=" +
        dataObject["typeValue"] +
        "&attendMode=" +
        dataObject["courseAttendMode"] +
        "&cardId=" +
        cardId +
        "&faceInfo=" +
        faceInfo +
        "&needSignIn=1";
      this.$router.push({
        path: url,
      });
    },
    clickScanCard(){
      window.swipingCardFunction(this.cardNumber , "");
    }
  }
}
</script>

<style>
.signbuttoncontent{
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  z-index: 9999;
}
</style>